var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.47619L12 0L24 6.47619V24H21V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V24H0V6.47619ZM6.5 11C5.67157 11 5 11.6716 5 12.5C5 13.3284 5.67157 14 6.5 14H17.5C18.3284 14 19 13.3284 19 12.5C19 11.6716 18.3284 11 17.5 11H6.5ZM5 17.5C5 16.6716 5.67157 16 6.5 16H17.5C18.3284 16 19 16.6716 19 17.5C19 18.3284 18.3284 19 17.5 19H6.5C5.67157 19 5 18.3284 5 17.5ZM6.5 21C5.67157 21 5 21.6716 5 22.5C5 23.3284 5.67157 24 6.5 24H17.5C18.3284 24 19 23.3284 19 22.5C19 21.6716 18.3284 21 17.5 21H6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.49929d83.svg";
export { ForwardRef as ReactComponent };